import {
    CREATE_DRIVER, VENDER_SEARCH_HUB_QUERY, GET_VENDOR_LIST,
    FETCH_ADDRESS_HIERARCHY_DATA, GET_BOTTOM_UP_HIERARCHY_FOR_ADDRESS_NODE, FETCH_ADDRESS_META_DATA,
} from 'src/api/routes';
import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';

const { API_BASE_URL } = config;

export const addDriver = async (body) => {
    return POST(`${API_BASE_URL}${CREATE_DRIVER}`, body);
};

export const updateDriver = async (id, body) => {
    return POST(`${API_BASE_URL}/VendorPortal/worker/${id}/update`, body);
};

export const fetchDriverInfo = async (body) => {
    return GET(`${API_BASE_URL}/VendorPortal/worker/${body?.workerId}/details`);
};

export const searchHubWithrealFilter = async (body) => {
    return GET(`${API_BASE_URL}${VENDER_SEARCH_HUB_QUERY}`, {
        hubType: body?.hubType || body?.defaultHubType,
        hubCategoryId: body?.hubCategoryId,
        realFilter: body?.realFilter,
        searchQuery: body?.searchQuery,
    });
};

export const getVendorList = async () => {
    return GET(`${API_BASE_URL}${GET_VENDOR_LIST}`);
};

export const getAddressHierarchyData = async (params) => {
    return GET(`${API_BASE_URL}${FETCH_ADDRESS_HIERARCHY_DATA}`, params);
};

export const getBottomUpHierarchyForAddressNode = async (params = {}) => {
    return GET(`${API_BASE_URL}${GET_BOTTOM_UP_HIERARCHY_FOR_ADDRESS_NODE}`, params);
};

export const fetchAddressMetadata = async () => {
    return GET(`${API_BASE_URL}${FETCH_ADDRESS_META_DATA}`);
};
